import { TextField, Divider, Chip, MenuItem } from "@mui/material";
import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";
import InputAdornment from "@mui/material/InputAdornment";
import * as React from "react";
import styled from "styled-components";
import BasicButtons from "../../UI/BasicButtons";
import Modal from "../../UI/Modal";
import Contragenty from "../../spravochniki/contragent/Contragenty";
import Dogovora from "../dogovor/Dogovora";
import { useCreatePaymentMutation } from "../../../store/paymentApi";
import { convertToInputDateTime } from "../../../utilits/helpers/convertDateFormat";
import { useGetPaymentCodeQuery } from "../../../store/paymentCodeApi";
import { useSelector } from "react-redux";


export default function CreatePayment({ onClose }) {
  const {id} = useSelector((state) => state.auth)
  const {data: paymentCodeFB} = useGetPaymentCodeQuery()
  const [addData] = useCreatePaymentMutation();
  const [docDate, setDocDate] = React.useState(convertToInputDateTime(new Date()));
  const [docNumber, setDocNumber] = React.useState("");
  const [amount, setAmount] = React.useState("");
  //   const [type, setType] = React.useState("");
  const [contragent, setContragent] = React.useState("");
  const [dogovor, setDogovor] = React.useState("");
  const [inn, setInn] = React.useState("");
  const [totalSum, setTotalSum] = React.useState("");
  const [dateDogovorFrom, setDateDogovorFrom] = React.useState("");
  const [dateDogovorTo, setDateDogovorTo] = React.useState("");
  const [modalForContragenty, setModalForContragenty] = React.useState(false);
  const [modalForDogovor, setModalForDogovor] = React.useState(false);
  const [contragentID, setContragentID] = React.useState("");
  const [dogovorID, setDogovorID] = React.useState("");
  const [invoice, setInvoice] = React.useState("");
  const [paymetCode, setPaymentCode] = React.useState([])
  const [paymentCodeID, setPaymentCodeID] = React.useState("")

  React.useEffect(() => {
    const setDataToStates = async () => {
      try {
        const paymentCodes = await paymentCodeFB.data;
        setPaymentCode(paymentCodes);
      } catch (error) {}
    };
    setDataToStates();
  }, [paymentCodeFB]);

  const inputChangeHandler = (event, setValue) => {
    setValue(event.target.value);
  };

  const getContragentItem = (item) => {
    setContragent(
      item.attributes.surname +
        " " +
        item.attributes.name +
        " " +
        item.attributes.lastname
    );
    setInn(item.attributes.inn);
    setContragentID(item.id);
  };

  const getDogovorItem = (item) => {
    setDogovor(item.attributes.numberDogovor);
    setInvoice(item.attributes.invoice);
    setTotalSum(item.attributes.totalSum);
    setDogovorID(item.id);
    setDateDogovorFrom(item.attributes.dateDogovorFrom);
    setDateDogovorTo(item.attributes.dateDogovorTo);
  };

  const formSubmitHandler = (event) => {
    event.preventDefault();
    window.confirm("Вы уверены?");
    const newData = {
      docNumber,
      dateTime: new Date(docDate),
      amount,
      type: "plus",
      contragent: contragentID,
      dogovor: dogovorID,
      user: id,
      payment_code: paymentCodeID,
    };
    addData(newData);
    onClose();
  };

  return (
    <StyledForm onSubmit={formSubmitHandler}>
      <TitleOfCreation>Оплата</TitleOfCreation>
      <BlockStyled margin="0 0 20px 0" width="100%">
        <BlockStyled width="100%" display="flex" justifyContent="flex-start">
          <TextFieldStylded
            id="datetime"
            type="datetime-local"
            InputLabelProps={{ shrink: true }}
            label="Дата документа"
            variant="outlined"
            value={docDate}
            onChange={(event) => inputChangeHandler(event, setDocDate)}
            size="small"
            width="200px"
            mrg="0 10px 0 0"
          />
          <TextFieldStylded
            id="outlined-basic"
            label="№ документа"
            variant="outlined"
            value={docNumber}
            onChange={(event) => inputChangeHandler(event, setDocNumber)}
            size="small"
            width="20%"
            mrg="0 15px 0 0"
          />
          <TextFieldStylded
            id="outlined-basic"
            label="Сумма"
            variant="outlined"
            value={amount}
            onChange={(event) => inputChangeHandler(event, setAmount)}
            size="small"
            width="150px"
            mrg="0 15px 0 0"
          />
          <TextFieldStylded
          id="select"
          select
          label="Код оплаты"
          variant="outlined"
          width="200px"
          size="small"
          value={paymetCode.length ? paymentCodeID : ""}
        >
          {paymetCode.map((item) => {
            return (
              <MenuItem
                key={item.id}
                value={item.id}
                onClick={() => setPaymentCodeID(item.id)}
              >
                {item.attributes.title}
              </MenuItem>
            );
          })}
        </TextFieldStylded>
          {/* <TextFieldStylded
            id="outlined-basic"
            label="Приход или расход"
            variant="outlined"
            value={type}
            onChange={(event) => inputChangeHandler(event, setType)}
            width="180px"
            size="small"
          /> */}
        </BlockStyled>
        <BlockStyled
          width="100%"
          margin="20px 0 0 0"
          display="flex"
          justifyContent="flex-start"
        >
          <TextFieldStylded
            InputLabelProps={{ shrink: true }}
            label="Контрагент"
            id="outlined-end-adornment"
            mrg="0 20px 0 0"
            size="small"
            width="45%"
            value={contragent}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconStyled
                    onClick={() => setModalForContragenty(true)}
                    color="primary"
                  />
                </InputAdornment>
              ),
            }}
          />
          <Modal
            fullwidth={"60%"}
            isOpen={modalForContragenty}
            onClose={() => setModalForContragenty(false)}
          >
            <Contragenty
              onCloseContragenty={() => setModalForContragenty(false)}
              getContragentItem={getContragentItem}
            />
          </Modal>
          <TextFieldStylded
            id="outlined-basic"
            label="ИНН"
            variant="outlined"
            value={inn}
            onChange={(event) => inputChangeHandler(event, setInn)}
            size="small"
            width="30%"
            mrg="0 20px 0 0"
          />
        </BlockStyled>
      </BlockStyled>
      <DividerStyled sx={{ margin: "20px 0" }} width="60%">
        <Chip label="Договор" />
      </DividerStyled>
      <BlockStyled
        margin="20px 0"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStylded
          InputLabelProps={{ shrink: true }}
          label="Договор №"
          id="outlined-end-adornment"
          width="15%"
          mrg="0 20px 0 0"
          value={dogovor}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconStyled
                  onClick={() => setModalForDogovor(true)}
                  color="primary"
                />
              </InputAdornment>
            ),
          }}
        />
        <Modal
          fullwidth={"60%"}
          isOpen={modalForDogovor}
          onClose={() => setModalForDogovor(false)}
        >
          <Dogovora
            onCloseDogovor={() => setModalForDogovor(false)}
            getDogovorItem={getDogovorItem}
          />
        </Modal>
        <TextFieldStylded
          id="outlined-basic"
          label="Лицевой счет"
          inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
          variant="outlined"
          value={invoice}
          onChange={(event) => inputChangeHandler(event, setInvoice)}
          width="15%"
          mrg="0 20px 0 0"
          disabled
        />
        <TextFieldStylded
          id="outlined-basic"
          label="Сумма договора"
          value={totalSum}
          onChange={(event) => inputChangeHandler(event, setTotalSum)}
          width="15%"
        />
        <BlockStyled
          display="flex"
          justifyContent="center"
          alignItems="center"
          margin="0 20px"
          width="10px"
        >
          с
        </BlockStyled>
        <TextFieldStylded
          id="date"
          type="date"
          InputLabelProps={{ shrink: true }}
          label="Сроки договора"
          variang="outlined"
          value={dateDogovorFrom}
          onChange={(event) => inputChangeHandler(event, setDateDogovorFrom)}
          width="150px"
        />
        <BlockStyled
          display="flex"
          justifyContent="center"
          alignItems="center"
          margin="0 20px"
          width="10px"
        >
          по
        </BlockStyled>
        <TextFieldStylded
          id="date"
          type="date"
          InputLabelProps={{ shrink: true }}
          label="Сроки договора"
          variant="outlined"
          value={dateDogovorTo}
          onChange={(event) => inputChangeHandler(event, setDateDogovorTo)}
          width="150px"
        />
      </BlockStyled>
      <StyledButtonsdBlock>
        <BlockStyled
          display="flex"
          flexDirection="flex-start"
          alignItems="center"
        >
          
        </BlockStyled>

        <BlockStyled display="flex" flexDirection="flex-end">
          <BasicButtons onClick={onClose}>Отменить</BasicButtons>
          <BasicButtons type="submit">Сохранить</BasicButtons>
        </BlockStyled>
      </StyledButtonsdBlock>
    </StyledForm>
  );
}

const BlockStyled = styled.div`
  width: ${(props) => props.width};
  display: ${(props) => props.display};
  justify-content: ${(props) => props.justifyContent};
  flex-direction: ${(props) => props.flexDirection};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  align-items: ${(props) => props.alignItems};
`;

const TextFieldStylded = styled(TextField)`
  width: ${(props) => props.width};
  margin: ${(props) => props.mrg};
`;

const DividerStyled = styled(Divider)`
  margin: ${(props) => props.margin};
`;
const IconStyled = styled(MoreHorizTwoToneIcon)`
  cursor: pointer;
`;
const StyledButtonsdBlock = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
`;
const TitleOfCreation = styled.h3`
  text-align: center;
`;

const StyledForm = styled.form``;
